import z from "zod";

export const zSample2Settings = z.object({
  mcEnableGradation: z.boolean(),
  mcAttrId: z.string().nullish(),
  sizeAttrId: z.string().nullish(),
});

export type ZSample2Settings = z.infer<typeof zSample2Settings>;
